export const getAccessibilityAttribute = (slug) => {
  return `accordion-item-${slug}`
}
